import { combineReducers } from "redux";

//Typescript with rtk query
import { violationManagerApiSlice } from "../callveriq/redux/services/settings/violationManager.service";
import { auditManagerApiSlice } from "../callveriq/redux/services/settings/auditManager.service";
import { roleManagerApiSlice } from "../callveriq/redux/services/settings/roleManager.service";
import { callTypeManagerApiSlice } from "../callveriq/redux/services/settings/callTypeManager.service";
import { callTagsManagerApiSlice } from "../callveriq/redux/services/settings/callTagsManager.service";
import { usersApiSlice } from "../callveriq/redux/services/settings/users.service";
import { scoreSenseApiSlice } from "@callveriq/redux/services/settings/scoreSense.service";
import { qmsApiSlice } from "@callveriq/redux/services/settings/qms.service";
import { customDashboardApiSlice } from "@callveriq/redux/services/home/customDashboard.service";
import { accountsApiSlice } from "@callveriq/redux/services/account/account.service";
import { entityApiSlice } from "@callveriq/redux/services/settings/entity.service";
import { activityApiSlice } from "@callveriq/redux/services/settings/activity.service";
import { userManagerApiSlice } from "../callveriq/redux/services/settings/userManager.service";
import { teamManagerSeviceSlice } from "@callveriq/redux/services/settings/teamManager.service";
import { domainApiSlice } from "@callveriq/redux/services/domain/domain.service";
import { billingApiSlice } from "@callveriq/redux/services/settings/billing.service";
import { lmsKnowledgeBaseApiSlice } from "@callveriq/redux/services/lms/lmsKnowledgeBase.service";
import { lmsAssessmentApiSlice } from "@callveriq/redux/services/lms/lmsAssesments.service";
import { analyticsDashboardApiSlice } from "@callveriq/redux/services/home/analyticsDashboard.service";
import { feedbackSlice } from "@callveriq/redux/services/Feedback/feedback.service";
import { scheduledReportsApiSlice } from "@callveriq/redux/services/settings/scheduledReport.service";
import { customerIntelligenceApiSlice } from "@callveriq/redux/services/customerIntelligence/customerIntelligence.service";
import { liveAssistApiSlice } from "@callveriq/redux/services/settings/liveAssist.service";
import { aiFeedbackSlice } from "@callveriq/redux/services/settings/aiFeedback.service";
import { notificationApiSlice } from "@callveriq/redux/services/notifications/notification.service";
import { supervisorAssistApiSlice } from "@callveriq/redux/services/supervisorAssist/supervisorAssist.service";
import { aiVoiceCallSlice } from "@callveriq/redux/services/aiVoiceCall/aiVoiceCall.service";
import { samplingManagerApiSlice } from "@callveriq/redux/services/settings/samplingManager.service";
import { filtersApiSlice } from "@callveriq/redux/services/meeting/filters.service";
import { conversationsApiSlice } from "@callveriq/redux/services/conversation/conversations.service";
import { commentApiSlice } from "@callveriq/redux/services/comment/comment.service";
import { auditSheetApiSlice } from "@callveriq/redux/services/audit/auditSheet.service";
import { meetingsApiSlice } from "@callveriq/redux/services/meeting/meeting.service";
import { authApiSlice } from "@callveriq/redux/services/auth/auth.service";
import { recommendationApiSlice } from "@callveriq/redux/services/settings/recommendation.service";
import { auditAiConfig } from "@callveriq/redux/services/settings/auditAiConfig.service";
import { coachingApiSlice } from "@callveriq/redux/services/coaching/coaching.service";
import { aiDispositionApiSlice } from "@callveriq/redux/services/settings/aiDisposition.service";
import { aiSummaryApiSlice } from "@callveriq/redux/services/settings/aiSummary.service";
import { personApiSlice } from "@callveriq/redux/services/auth/person.service";
import { internalCoachingApiSlice } from "@callveriq/redux/services/settings/internalCoaching.service";
import { recordingManagerApiSlice } from "@callveriq/redux/services/settings/recordingManager.service";
import { sentimentAnalysisApiSlice } from "@callveriq/redux/services/settings/sentimentAnalysis.service";
import { topicManagerApiSlice } from "@callveriq/redux/services/settings/topicManager.service";
import { integrationManagerApiSlice } from "@callveriq/redux/services/settings/integrationManager.service";
import { liveConversationApiSlice } from "@callveriq/redux/services/settings/liveConversation.service";
import { acptApiSlice } from "@callveriq/redux/services/settings/acpt.service";
import { internalAHTApiSlice } from "@callveriq/redux/services/settings/internalAHT.service";
import { dashboardReportConfigApiSlice } from "@callveriq/redux/services/settings/dashboardReportConfig.service";
import { subdomainConfigApiSlice } from "@callveriq/redux/services/settings/subdomainConfig.service";
import { internalToolsApiSlice } from "@callveriq/redux/services/settings/internalTools/internalTools.service";
import { AnyAction } from "@reduxjs/toolkit";

// Combine all reducers.
const appReducer = combineReducers({
    [auditManagerApiSlice.reducerPath]: auditManagerApiSlice.reducer,
    [roleManagerApiSlice.reducerPath]: roleManagerApiSlice.reducer,
    [violationManagerApiSlice.reducerPath]: violationManagerApiSlice.reducer,
    [callTypeManagerApiSlice.reducerPath]: callTypeManagerApiSlice.reducer,
    [callTagsManagerApiSlice.reducerPath]: callTagsManagerApiSlice.reducer,
    [usersApiSlice.reducerPath]: usersApiSlice.reducer,
    [internalCoachingApiSlice.reducerPath]: internalCoachingApiSlice.reducer,
    [scoreSenseApiSlice.reducerPath]: scoreSenseApiSlice.reducer,
    [qmsApiSlice.reducerPath]: qmsApiSlice.reducer,
    [aiFeedbackSlice.reducerPath]: aiFeedbackSlice.reducer,
    [customDashboardApiSlice.reducerPath]: customDashboardApiSlice.reducer,
    [activityApiSlice.reducerPath]: activityApiSlice.reducer,
    [userManagerApiSlice.reducerPath]: userManagerApiSlice.reducer,
    [teamManagerSeviceSlice.reducerPath]: teamManagerSeviceSlice.reducer,
    [accountsApiSlice.reducerPath]: accountsApiSlice.reducer,
    [entityApiSlice.reducerPath]: entityApiSlice.reducer,
    [domainApiSlice.reducerPath]: domainApiSlice.reducer,
    [billingApiSlice.reducerPath]: billingApiSlice.reducer,
    [lmsKnowledgeBaseApiSlice.reducerPath]: lmsKnowledgeBaseApiSlice.reducer,
    [lmsAssessmentApiSlice.reducerPath]: lmsAssessmentApiSlice.reducer,
    [analyticsDashboardApiSlice.reducerPath]:
        analyticsDashboardApiSlice.reducer,
    [feedbackSlice.reducerPath]: feedbackSlice.reducer,
    [scheduledReportsApiSlice.reducerPath]: scheduledReportsApiSlice.reducer,
    [customerIntelligenceApiSlice.reducerPath]:
        customerIntelligenceApiSlice.reducer,
    [liveAssistApiSlice.reducerPath]: liveAssistApiSlice.reducer,
    [aiSummaryApiSlice.reducerPath]: aiSummaryApiSlice.reducer,
    [acptApiSlice.reducerPath]: acptApiSlice.reducer,
    [notificationApiSlice.reducerPath]: notificationApiSlice.reducer,
    [supervisorAssistApiSlice.reducerPath]: supervisorAssistApiSlice.reducer,
    [aiVoiceCallSlice.reducerPath]: aiVoiceCallSlice.reducer,
    [samplingManagerApiSlice.reducerPath]: samplingManagerApiSlice.reducer,
    [filtersApiSlice.reducerPath]: filtersApiSlice.reducer,
    [conversationsApiSlice.reducerPath]: conversationsApiSlice.reducer,
    [commentApiSlice.reducerPath]: commentApiSlice.reducer,
    [auditSheetApiSlice.reducerPath]: auditSheetApiSlice.reducer,
    [meetingsApiSlice.reducerPath]: meetingsApiSlice.reducer,
    [authApiSlice.reducerPath]: authApiSlice.reducer,
    [recommendationApiSlice.reducerPath]: recommendationApiSlice.reducer,
    [auditAiConfig.reducerPath]: auditAiConfig.reducer,
    [coachingApiSlice.reducerPath]: coachingApiSlice.reducer,
    [aiDispositionApiSlice.reducerPath]: aiDispositionApiSlice.reducer,
    [personApiSlice.reducerPath]: personApiSlice.reducer,
    [recordingManagerApiSlice.reducerPath]: recordingManagerApiSlice.reducer,
    [sentimentAnalysisApiSlice.reducerPath]: sentimentAnalysisApiSlice.reducer,
    [topicManagerApiSlice.reducerPath]: topicManagerApiSlice.reducer,
    [integrationManagerApiSlice.reducerPath]:
        integrationManagerApiSlice.reducer,
    [liveConversationApiSlice.reducerPath]: liveConversationApiSlice.reducer,
    [internalAHTApiSlice.reducerPath]: internalAHTApiSlice.reducer,
    [dashboardReportConfigApiSlice.reducerPath]:
        dashboardReportConfigApiSlice.reducer,
    [subdomainConfigApiSlice.reducerPath]: subdomainConfigApiSlice.reducer,
    [internalToolsApiSlice.reducerPath]: internalToolsApiSlice.reducer,
});

export const rootReducer = (
    state: ReturnType<typeof appReducer> | undefined,
    action: AnyAction
) => {
    return appReducer(state, action);
};
